import { Outlet, NavLink, useNavigate } from 'react-router-dom'
import { useAuth } from '../../hooks/useAuth'
import { MedilaneLockup } from '../brand/Logo'
import './AdminLayout.css'

const NAV_ITEMS = [
  { path: '/admin', label: 'Dashboard', icon: '📊', end: true },
  { path: '/admin/pflegekraefte', label: 'Pflegekräfte', icon: '👥' },
  { path: '/admin/arbeitgeber', label: 'Arbeitgeber', icon: '🏢' },
  { path: '/admin/stellen', label: 'Stellen', icon: '📋' },
  { path: '/admin/matching', label: 'Matching', icon: '🎯' },
  { path: '/admin/pipeline', label: 'Pipeline', icon: '📈' },
]

export default function AdminLayout() {
  const { adminUser, signOut } = useAuth()
  const navigate = useNavigate()

  const handleSignOut = async () => {
    await signOut()
    navigate('/login')
  }

  return (
    <div className="admin-layout">
      <aside className="admin-sidebar">
        <div className="sidebar-header">
          <MedilaneLockup size={28} variant="inverse" />
          <span className="sidebar-badge">Admin</span>
        </div>

        <nav className="sidebar-nav">
          {NAV_ITEMS.map((item) => (
            <NavLink
              key={item.path}
              to={item.path}
              end={item.end}
              className={({ isActive }) =>
                `sidebar-link ${isActive ? 'sidebar-link--active' : ''}`
              }
            >
              <span className="sidebar-link-icon">{item.icon}</span>
              <span className="sidebar-link-label">{item.label}</span>
            </NavLink>
          ))}
        </nav>

        <div className="sidebar-footer">
          <div className="sidebar-user">
            <div className="sidebar-user-avatar">
              {adminUser?.name?.charAt(0) || '?'}
            </div>
            <div className="sidebar-user-info">
              <span className="sidebar-user-name">{adminUser?.name || 'Admin'}</span>
              <span className="sidebar-user-role">
                {adminUser?.rolle === 'admin' ? 'Administrator' : 'Recruiter'}
              </span>
            </div>
          </div>
          <button className="sidebar-logout" onClick={handleSignOut} title="Abmelden">
            🚪
          </button>
        </div>
      </aside>

      <main className="admin-main">
        <Outlet />
      </main>
    </div>
  )
}
